<template>
    <div class="layout-wrapper">
        <header>
            <nav class="navbar navbar-inverse">
                <div class="container">
                    <div class="navbar-header">
                        <button v-on:click="openExpander" type="button" id="nav-expander" class="navbar-toggle nav-expander">
                            <span class="icon-bar"></span>
                            <span class="icon-bar"></span>
                            <span class="icon-bar"></span>
                        </button>
                        <router-link to="/">
                            <a class="navbar-brand"><img src="images/logo.png" alt="FRL logo"></a>
                        </router-link>
                    </div>
                    <div class="main-menu text-center">
                        <ul class="nav navbar-nav">
                            <li class="nav-close hidden-md hidden-lg">
                                <a v-on:click="closeExpander" id="nav-close">
                                    <i class="fa fa-times" aria-hidden="true"></i>
                                </a>
                            </li>
                            <router-link to="/" tag="li" active-class="active" exact>
                                <a>HOME</a>
                            </router-link>
                            <router-link to="/proven-benefits" tag="li" active-class="active" :class="{'active':isProject}">
                                <a>BRICK FUNDRAISING</a>
                                <div class="dropdown">
                                    <router-link to="/proven-benefits" active-class="active">
                                        Proven Benefits
                                    </router-link>
                                    <router-link to="/unmatched-quality" active-class="active">
                                        Unmatched Quality
                                    </router-link>
                                    <router-link to="/fundraising-toolkit" active-class="active">
                                        Fundraising Toolkit
                                    </router-link>
                                    <router-link to="/product-guide" active-class="active">
                                        Product Guide
                                    </router-link>
                                    <router-link to="/how-it-works" active-class="active">
                                        How It Works
                                    </router-link>
                                </div>
                            </router-link>
                            <router-link to="/portfolio" tag="li" active-class="active" :class="{'active':isPortfolio}">
                                <a>PORTFOLIO</a>
                            </router-link>
                            <router-link to="/about-us" tag="li" active-class="active">
                                <a>ABOUT US</a>
                            </router-link>
                            <router-link to="/faq" tag="li" active-class="active">
                                <a>FAQ</a>
                            </router-link>
                            <router-link to="/contact" tag="li" active-class="active">
                                <a>CONTACT</a>
                            </router-link>
                        </ul>
                    </div>
                </div>
            </nav>
        </header>

        <section class="section-wrapper">
            <div class="page-wrap">
                <div class="main-container">
                    <div class="intro-offer-teaser" v-if="$route.path !== '/intro-offer'">
                        <!--<router-link to="/intro-offer" tag="div" class="offer-content">
                            <p>
                                *INTRODUCTORY OFFER FOR YOUR NON-PROFIT ORGANIZATION*
                                <span>Click here to learn more.</span>
                            </p>
                        </router-link>-->
                    </div>
                    <component :is="this.$route.meta.layout || 'div'">
                        <router-view />
                    </component>
                </div>
            </div>

            <div class="page-footer safari-only">
                <div class="container">
                    <div class="row">
                        <div class="pf-inner">
                            <p>START YOUR FUNDRAISER TODAY!</p>
                            <router-link to="/open-contact-form" tag="button">
                                <span>REQUEST MORE INFORMATION</span>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <footer class="main-footer">
            <div class="container">
                <div class="row">

                    <div class="footer-inner">
                        <p>&copy; 2018 Fund Raisers, Ltd. All Rights Reserved.</p>
                        <p class="privacy-policy">
                            <a href="https://fundraiserssports.com/privacy-policy" target="_blank">Privacy Policy</a>
                        </p>
                        <ul class="social list-inline">
                            <li class="facebook"><a href="https://www.facebook.com/fundraiserssports/" target="_blank"></a></li>
                            <li class="linkedin"><a href="https://www.linkedin.com/company/fund-raisers-sports" target="_blank"></a></li>
                            <li class="twitter"><a href="https://twitter.com/TeamFundRaisers" target="_blank"></a></li>
                            <li class="instagram"><a href="https://www.instagram.com/fundraiserssports/" target="_blank"></a></li>
                            <li class="pinterest"><a href="https://www.pinterest.com/fundraiserssports/" target="_blank"></a></li>
                        </ul>
                        <p>
                            <a href="http://www.fundraiserssports.com/" target="_blank">
                                <span class="footer-text">FUND RAISERS SPORTS</span>
                            </a>
                        </p>
                    </div>

                </div>
            </div>
        </footer>
        <inscription-guidelines-popup></inscription-guidelines-popup>
        <inscription-examples-popup></inscription-examples-popup>
    </div>
</template>

<script type="text/jsx">
    import { mapMutations } from 'vuex'
    // popups
    import InscriptionGuidelines from '@/components/content/InscriptionGuidelines.vue';
    import InscriptionExamples from '@/components/content/InscriptionExamples.vue';
    export default {
        name: 'Website',
        metaInfo: {
            title: 'Fund Raisers, Ltd.',
            titleTemplate: 'Fund Raisers, Ltd. | %s'
        },
        mixins: [
        ],
        data: function () {
            return this.getDefaultData();
        },
        components: {
            'inscription-guidelines-popup': InscriptionGuidelines,
            'inscription-examples-popup': InscriptionExamples
        },
        created: function () {
        },
        mounted: function () {
            this.$router.afterEach((to, from) => {
                // console.log('ROUTER:', to, from);
                if (this.navExpanderOpen) {
                    this.closeExpander();
                    // window.scrollTo(0, 0);
                } else if (this.$mq.below(993)) {
                    // window.scrollTo(0, 0);
                }
                window.scrollTo(0, 0);
            });
        },
        beforeDestroy: function () {
        },
        watch: {
            navExpanderOpen: function (newVal) {
                var className = 'nav-expanded';
                if (newVal) {
                    document.body.classList.add(className);
                } else {
                    document.body.classList.remove(className);
                }
            }
        },
        methods: {
            getDefaultData: function () {
                return {
                }
            },

            // mobile navigation menu
            ...mapMutations(['openExpander', 'closeExpander']),
        },
        computed: {
            navExpanderOpen: function () {
                return this.$store.state.navExpanderOpen
            },
            isPortfolio() {
                var layout = 'layout' in this.$route.meta
                    ? this.$route.meta.layout
                    : {};
                return ('name' in layout && layout.name === 'Portfolio');
            },
            isProject() {
                var isProject = 'isProject' in this.$route.meta
                    ? this.$route.meta.isProject
                    : false;
                return isProject;
            }
        }
    }
</script>

<style lang="css">
    [v-cloak] {
        display: none;
    }
    .pointer {
        cursor: pointer;
    }
    .validated {
        color: green;
    }
    .no-select {
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
        -khtml-user-select: none; /* Konqueror HTML */
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none; /* Non-prefixed version, currently supported by Chrome and Opera */
    }
    label.has-error:before {
        border: 1px solid #750020; /* aka $brand-danger */
        background-color: #f0d2d2;
    }
    [type="checkbox"].check-style + label.has-error:before {
        border: 1px solid #750020; /* aka $brand-danger */
        background-color: #f0d2d2;
    }
    .modal-open {
        overflow-x: hidden;
        overflow-y: auto;
    }
</style>



// WEBPACK FOOTER //
// Website.vue?76185627